/**
 * Dois modos de densidade.
 *
 * `compacta` é o PADRÃO, com linha de 32px. Isso não é escolha estética:
 * o público veio do Excel, e densidade compacta é paridade com a ferramenta
 * que estamos substituindo. Uma tela que mostra 12 linhas onde o Excel
 * mostrava 30 é percebida como regressão, por melhor que seja o resto.
 *
 * `confortavel` existe para monitor pequeno, apresentação e acessibilidade
 * motora — alvo de clique maior.
 */

export type ModoDeDensidade = 'compacta' | 'confortavel';

export interface Densidade {
  /** Altura da linha de tabela, em px. */
  readonly alturaDeLinha: number;
  /** Altura do cabeçalho de tabela, em px. */
  readonly alturaDeCabecalho: number;
  /** Padding vertical/horizontal da célula. */
  readonly paddingDaCelula: string;
  /** Padding do conteúdo de cartão e de página. */
  readonly paddingDeSecao: number;
  /** Espaço entre blocos, em múltiplos de 8px do MUI. */
  readonly espacoEntreBlocos: number;
}

export const DENSIDADE_PADRAO: ModoDeDensidade = 'compacta';

export const densidades: Record<ModoDeDensidade, Densidade> = {
  compacta: {
    alturaDeLinha: 32,
    alturaDeCabecalho: 36,
    paddingDaCelula: '4px 8px',
    paddingDeSecao: 2,
    espacoEntreBlocos: 2,
  },
  confortavel: {
    alturaDeLinha: 40,
    alturaDeCabecalho: 44,
    paddingDaCelula: '8px 12px',
    paddingDeSecao: 3,
    espacoEntreBlocos: 3,
  },
};

export const modosDeDensidade: readonly ModoDeDensidade[] = ['compacta', 'confortavel'];
